/** @jsxImportSource @emotion/react */

import { useCSSRulesWithTheme } from "hooks/useCSSRulesWithTheme";
import { FC } from "react";
import config from "config";

interface InterviewSchedulerProps {
  calLink: string;
}

const getCSSRules = () => ({
  iframe: {
    margin: 0,
    padding: 0,
    width: "100%",
    height: 550,
    border: "none",
  },
});

const InterviewScheduler: FC<InterviewSchedulerProps> = ({ calLink }) => {
  const styles = useCSSRulesWithTheme(getCSSRules);

  return (
    <iframe
      src={`${config.REACT_APP_CORE_PLATFORM_URL}/book/${calLink}`}
      css={styles.iframe}
    />
  );
};

export default InterviewScheduler;
